import React from 'react';

export function ProgressBar({
  value = 0, // 0 to 100
  label,
  subLabel,
  color = '#059669',
  height = '8px',
  animated = true,
  className = '',
  style = {}
}) {
  const clamped = Math.min(100, Math.max(0, Math.round(value)));

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', width: '100%', ...style }} className={className}>
      {(label || subLabel) && (
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: '13px' }}>
          {label && <span style={{ fontWeight: 600, color: 'var(--text-main)' }}>{label}</span>}
          {subLabel ? (
            <span style={{ color: 'var(--text-muted)' }}>{subLabel}</span>
          ) : (
            <span style={{ fontWeight: 700, color }}>{clamped}%</span>
          )}
        </div>
      )}
      <div
        style={{
          width: '100%',
          height,
          background: 'rgba(255, 255, 255, 0.08)',
          borderRadius: 'var(--radius-full)',
          overflow: 'hidden',
          position: 'relative'
        }}
      >
        <div
          style={{
            width: `${clamped}%`,
            height: '100%',
            background: `linear-gradient(90deg, ${color} 0%, #10B981 100%)`,
            borderRadius: 'var(--radius-full)',
            transition: 'width 0.3s ease',
            boxShadow: `0 0 10px ${color}80`
          }}
        />
      </div>
    </div>
  );
}

export default ProgressBar;
